import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import type { DashboardMetricsDTO } from '../types'

interface DashboardCardsProps {
  metrics: DashboardMetricsDTO
}

export function DashboardCards({ metrics }: DashboardCardsProps) {
  return (
    <div className='grid gap-4 sm:grid-cols-2 lg:grid-cols-4'>
      <CardItem
        title={metrics.total_conversations.title}
        value={metrics.total_conversations.value}
        description={metrics.total_conversations.change_description}
        icon={<MessageIcon />}
      />
      <CardItem
        title={metrics.conversations_with_interaction.title}
        value={metrics.conversations_with_interaction.value}
        description={metrics.conversations_with_interaction.change_description}
        icon={<InteractionIcon />}
      />
      <CardItem
        title={metrics.average_wait_time.title}
        value={metrics.average_wait_time.value}
        description={metrics.average_wait_time.change_description}
        icon={<ClockIcon />}
      />
      <CardItem
        title={metrics.average_service_time.title}
        value={metrics.average_service_time.value}
        description={metrics.average_service_time.change_description}
        icon={<TimerIcon />}
      />
    </div>
  )
}

interface CardItemProps {
  title: string
  value: string
  description: string | null
  icon: React.ReactNode
}

function CardItem({ title, value, description, icon }: CardItemProps) {
  return (
    <Card>
      <CardHeader className='flex flex-row items-center justify-between space-y-0 pb-2'>
        <CardTitle className='text-sm font-medium'>{title}</CardTitle>
        {icon}
      </CardHeader>
      <CardContent>
        <div className='text-2xl font-bold'>{value}</div>
        {description && (
          <p className='text-xs text-muted-foreground'>{description}</p>
        )}
      </CardContent>
    </Card>
  )
}

function MessageIcon() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='2'
      className='h-4 w-4 text-muted-foreground'
    >
      <path d='M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z' />
    </svg>
  )
}

function InteractionIcon() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='2'
      className='h-4 w-4 text-muted-foreground'
    >
      <path d='M17 8h2a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-2v4l-4-4H9a2 2 0 0 1-2-2v-1' />
      <path d='M7 15H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h2V1l4 4h6a2 2 0 0 1 2 2v3' />
    </svg>
  )
}

function ClockIcon() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='2'
      className='h-4 w-4 text-muted-foreground'
    >
      <circle cx='12' cy='12' r='10' />
      <polyline points='12 6 12 12 16 14' />
    </svg>
  )
}

function TimerIcon() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='2'
      className='h-4 w-4 text-muted-foreground'
    >
      <path d='M10 2h4' />
      <path d='M12 14v-4' />
      <path d='M4 13a8 8 0 0 1 8-7 8 8 0 1 1-5.3 14L4 17.6' />
      <path d='M9 17H4v5' />
    </svg>
  )
}
